// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2njCq","content":"styles_content__eZPV3","tableWrap":"styles_tableWrap__1CaYc"};